import request from './request';

export const fetchUserServices = () =>
  request({
    method: 'GET',
    url: '/users/services',
    protectedRoute: true,
    newApi: true
  });

export const fetchServices = () =>
  request({
    method: 'GET',
    url: '/common/services',
    protectedRoute: true,
    newApi: true
  });

export const updateUserService = (data) =>
  request({
    method: 'PUT',
    url: `/users/me/services/${data.id}`,
    data,
    protectedRoute: true,
    newApi: true
  });
